import { useState } from "react"
import { FiMonitor, FiTrash2 } from "react-icons/fi"
import { Button } from "../components/ui/button"
import { useScreens } from "../hooks/useScreens"
import DialogComponent from "./shared/Dialog"

export interface ManageSyncedDevicesProps {
  groupId: number
}

export function ManageSyncedDevices({ groupId }: ManageSyncedDevicesProps) {
  // const { screenInfo } = useScreen()
  const { screens, updateScreen } = useScreens()
  const [manageDevicesDialogOpen, setManageDevicesDialogOpen] = useState(false)
  const [confirmUnsyncDialogOpen, setConfirmUnsyncDialogOpen] = useState(false)
  const [selectedScreenId, setSelectedScreenId] = useState<string | null>(null)

  const syncedScreens = screens.filter(s => s.group_id === groupId)

  const handleManageDevices = () => {
    setManageDevicesDialogOpen(true)
  }

  const handleUnsyncConfirm = () => {
    if (selectedScreenId) {
      updateScreen({ screenId: selectedScreenId, data: { group_id: null } })
      setConfirmUnsyncDialogOpen(false)
    }
  }

  const handleUnsyncClick = (screenId: string) => {
    setSelectedScreenId(screenId)
    setConfirmUnsyncDialogOpen(true)
  }

  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        onClick={handleManageDevices}
        className="text-muted-foreground hover:text-foreground"
      >
        <FiMonitor className="mr-2 h-4 w-4" />
        Manage Devices
      </Button>
      <DialogComponent
        closeDialog={() => setManageDevicesDialogOpen(false)}
        isDialogOpen={manageDevicesDialogOpen}
        dialogInfo={{
          title: "Manage Synced Devices",
          customContent: (
            <div className="space-y-4 p-4">
              {syncedScreens.length === 0 ? (
                <p className="text-center text-muted-foreground">No devices are currently synced</p>
              ) : (
                <div className="space-y-3">
                  {syncedScreens.map((screen) => (
                    <div key={screen.id} className="flex items-center justify-between rounded-lg border p-3">
                      <div className="flex items-center space-x-3">
                        <FiMonitor className="h-5 w-5 text-muted-foreground" />
                        <div>
                          <p className="font-medium">{screen.name}</p>
                        </div>
                      </div>
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => handleUnsyncClick(screen.id!)}
                      >
                        <FiTrash2 className="h-4 w-4 text-destructive" />
                      </Button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ),
        }}
      />
      <DialogComponent
        closeDialog={() => setConfirmUnsyncDialogOpen(false)}
        isDialogOpen={confirmUnsyncDialogOpen}
        dialogInfo={{
          title: "Confirm Unsync",
          description: "Are you sure you want to unsync this device? This will remove it from the current music group.",
          dialogType: "confirm",
          onConfirm: handleUnsyncConfirm,
          onCancel: () => setConfirmUnsyncDialogOpen(false),
        }}
      />
    </>
  )
}